import { useLayoutEffect, useRef, useState } from 'react';

const PANEL_WIDTH = 344;

export default function WebNotificationPreview({ content, host, rtl }) {
    const desktop = useRef(null);
    const panel = useRef(null);
    const [size, setSize] = useState({ width: 440, height: 170 });
    useLayoutEffect(() => {
        const measure = () => {
            const next = { width: desktop.current?.clientWidth || 440, height: panel.current?.offsetHeight || 170 };
            setSize((old) => old.width === next.width && old.height === next.height ? old : next);
        };
        measure();
        if (globalThis.ResizeObserver) {
            const observer = new ResizeObserver(measure);
            if (desktop.current) observer.observe(desktop.current);
            if (panel.current) observer.observe(panel.current);
            return () => observer.disconnect();
        }
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [content.title, content.body, host]);
    const scale = Math.min(1, Math.max(1, size.width - 24) / PANEL_WIDTH);
    return <section ref={desktop} className="push-web-desktop" aria-label="电脑端右上角通知预览" style={{ height: Math.max(220, size.height * scale + 44) }}>
        <div className="push-web-window-bar" aria-hidden="true"><i /><i /><i /><span /></div>
        <div className="push-web-window-content" aria-hidden="true"><span /><span /><span /></div>
        <div ref={panel} className="push-web-notification-center" style={{ width: PANEL_WIDTH, transform: `scale(${scale})` }}>
            <div className="push-web-center-heading"><span>Notification Center</span><span className="push-web-dismiss" aria-hidden="true">×</span></div>
            <div className="push-web-notification" aria-label="通知卡片预览">
                <img className="push-web-browser-icon" src="/images/chrome-browser-icon.png" alt="Chrome 浏览器图标" />
                <div className="push-web-notification-copy" dir={rtl ? 'rtl' : 'auto'}>
                    <strong>{content.title || '通知标题'}</strong>
                    <div className="push-web-origin" dir="ltr">{host}</div>
                    <p>{content.body || '填写正文后在这里预览'}</p>
                </div>
                <img className="push-web-site-icon" src="/images/goai-web-icon.png" alt="GoAI 网站图标" />
            </div>
            <div className="push-web-center-footer" aria-hidden="true"><span>Edit Widgets</span><span className="push-web-dismiss">×</span></div>
        </div>
    </section>;
}
